import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {Injectable} from "@angular/core";
import {DxLogger} from "../services/dx-logger.service";
import {finalize, tap} from "rxjs/internal/operators";


/**
 * Перехватчик для логгирования http-запросов.
 * Сделан больше для примера использования перехватчиков и, лишь, замеряет тайминг запроса.
 * @publicApi
 */
@Injectable()
export class DxLoggingInterceptor implements HttpInterceptor {

  /**
   * Создает инстанс логгирующего перехватчика.
   * @constructor
   * @param {DxLogger} _logger - сервис логгирования.
   */
  constructor(private _logger: DxLogger) {}


  /**
   * Перехватывает `http`-запрос. Имплементация метода `intercept` интерфэйса `HttpInterceptor`.
   * @override
   * @param {HttpRequest<any>} request - исходящий `http`-запрос.
   * @param {HttpHandler} next - следующий перехватчик в цепи.
   * @return {Observable<HttpEvent<any>>} - обсервэбл-объект на инстанс `HttpEvent<any>`.
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startTime: number = Date.now();
    let status: string;
    return next
      .handle(request)
      .pipe(
        tap(
          event => {
            if(event instanceof HttpResponse) {
              status = 'SUCCEEDED'
            }
          },
          error => status = 'FAILED'
        ),
        finalize(() => {
          const elapsedTime = Date.now() - startTime;
          let msg = request.method + ': ' + request.urlWithParams + ' ';
          msg += 'performed with status ' + status + ' ';
          msg += 'in ' + elapsedTime + ' ms';
          this._logger.debug(msg);
        })
      );
  }
}
